import './App.css';
import { Amplify } from 'aws-amplify';
import { Authenticator, withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useMemo, useState } from 'react';
import { Root } from './components/Root';
import { Box, ThemeProvider, Typography, createTheme, useMediaQuery } from '@mui/material';

Amplify.configure({
  // "aws_project_region": "ap-northeast-1", いらない?
  // "aws_cognito_identity_pool_id": "ap-northeast-1:5f5986ca-3915-4d76-9457-f1710cd2e3e8",
  // "aws_cognito_region": "ap-northeast-1",
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_CLIENT_ID,
});

function App() {

  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = useMemo(
    () =>
      createTheme({
        // palette: {
        //   mode: prefersDarkMode ? 'dark' : 'light',
        // },
      }),
    [prefersDarkMode],
  );

  return (
    <ThemeProvider theme={theme}>
      <Authenticator>
        {({ signOut, user }) => {
          return <Root signOut={signOut} user={user} />
        }}
      </Authenticator>
    </ThemeProvider>
  );
}

const Header = () => (
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/logo_large.png`}
    sx={{ width: "100%", mb: 2, p: 2 }}
  />
)

const Footer = () => (
  <Typography sx={{
    width: "100%",
    textAlign: "center",
    p: 2,
    color: "text.secondary",
    fontSize: "small"
  }}>
    &copy; 2023 Business Engineering Coorperation
  </Typography>
)

export default withAuthenticator(
  App,
  {
    components: { Header, Footer },
    hideSignUp: true
  }
);
